import { getPhoneNumberCountryCodeAsNumber } from 'lib-shared-phone-numbers';
import { connect } from 'react-redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';
import { AppDispatch } from 'bootstrap.store';
import { AddUserPayload, userModalActions } from 'components/usersModal';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { notificationActions } from '../../../notifications/actions/notification';
import * as telephonyActions from '../../../telephony/actions/telephony';
import { transferToNumberActions } from '../actions/transferToNumberModal';
import TransferToNumberModal from '../components/TransferToNumberModal';

const { telephonyResetHold } = telephonyActions.actions;
const { notificationAdd, notificationRemoveByType } = notificationActions;

const mapStateToProps = (state: RootReducerStateT) => {
  const selectedFromNumber = state.telephony.selectedFromNumber;
  let fromNumberCountryCode: number | undefined = 45;

  if (selectedFromNumber && selectedFromNumber.e164_format) {
    fromNumberCountryCode = getPhoneNumberCountryCodeAsNumber(
      selectedFromNumber.e164_format,
    );
  }

  return {
    meta: state.transferToNumber.meta,
    ui: state.transferToNumber.ui,
    numberTransferRequests: state.transferToNumber.transferRequests,
    users: state.transferToNumber.users,
    metaConversation: state.transferToNumber.metaConversation,

    presenceMeta: state.presence.meta,
    profile: state.settings.profile.profile,
    allPresence: state.presence.allPresence,
    presence: state.presence.presence,

    transferToQueueRequests: state.transferToQueue.requests,
    transferToAgentRequests: state.transferToAgent.transferRequests,

    fromNumberCountryCode: fromNumberCountryCode,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    transferToNumberAssistedRequest: bindActionToPromise(
      dispatch,
      transferToNumberActions.transferToNumberAssistedRequest,
    ),
    transferToNumberBlindRequest: bindActionToPromise(
      dispatch,
      transferToNumberActions.transferToNumberBlindRequest,
    ),

    transferToNumberAssistedResolve: bindActionToPromise(
      dispatch,
      transferToNumberActions.transferToNumberAssistedResolve,
    ),

    getUsersByQuery: bindActionToPromise(
      dispatch,
      transferToNumberActions.transferToNumberGetUsersByQuery,
    ),

    userModalAddUser: (payload: AddUserPayload) =>
      dispatch(userModalActions.user.add(payload)),
    transferToNumberResetUsers: () =>
      dispatch(transferToNumberActions.transferToNumberResetUsers()),
    transferToNumberModalOpen: () =>
      dispatch(transferToNumberActions.transferToNumberModalOpen()),
    transferToNumberModalClose: () =>
      dispatch(transferToNumberActions.transferToNumberModalClose()),
    transferRequestStop: (csid: string) =>
      dispatch(transferToNumberActions.transferToNumberRequestStop({ csid })),
    notificationAdd: (payload: any) => dispatch(notificationAdd(payload)),
    notificationRemoveByType: (payload: any) =>
      dispatch(notificationRemoveByType(payload)),

    telephonyResetHold: () => dispatch(telephonyResetHold()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransferToNumberModal as any);
